import { useCallback } from 'react';
import messageQueue from '../utils/MessageQueue';

const useSendMessage = (ws) => {
  const sendMessage = useCallback((message) => {
    if (ws) {
      console.log(`[useSendMessage] Attempting to send message. WS readyState: ${ws.readyState}`, message);
      if (ws.readyState === WebSocket.OPEN) {
        try {
          ws.send(JSON.stringify(message));
          console.log(`[useSendMessage] Message sent successfully:`, message);
        } catch (e) {
          console.error(`[useSendMessage] ws.send error:`, e);
          console.log(`[useSendMessage] Queuing message after send error:`, message);
          messageQueue.enqueue(message);
        }
      } else {
        console.log(`[useSendMessage] WS not open (state: ${ws.readyState}). Queuing message:`, message);
        messageQueue.enqueue(message);
      }
    } else {
      console.warn(`[useSendMessage] WS is null. Cannot send message.`, message);
    }
  }, [ws]);

  return sendMessage;
};

export default useSendMessage;
